<template>
    <div>
        <b-form-group
            :label="$t('people.searchByName')"
            :description="$t('people.instructions.bulkSearch')"
        >
            <c-text-area id="bulk-search" :value.sync="bulkSearch" />
        </b-form-group>
    </div>
</template>

<script>
import { CTextArea } from '@/views/components/fields'

export default {
    name: 'BulkSearch',
    components: {
        CTextArea,
    },
    data() {
        return {
            bulkSearch: null,
        }
    },
    methods: {
        parseStringToArray() {
            const string = this.bulkSearch ? this.bulkSearch : ''
            return string.length == 0 ? [] : string.split('\n')
        },
    },
    watch: {
        bulkSearch() {
            const searchArray = this.parseStringToArray()
            this.$emit('changed', searchArray)
        },
    },
}
</script>
